import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import FeedbackForm from 'js/components/feedback_form';
import FeedbackPanel from 'js/components/feedback_panel';
import Star from 'js/components/star';
import Rate from 'js/components/rate';

import './index.scss';

const feedbackOptions = [
    {id: 'really_like', text: 'I really like this content', icon: 'star-gray'},
    {id: 'not_important', text: 'Missed guideline not important', icon: 'thumbs-up'},
    {id: 'other_campaign', text: 'Good for another campaign', icon: 'reuse'}
];

export default class MissedGuidelinesApprovedFeedback extends Component {
    static defaultProps = {
        onCancel: R.identity,
        onSubmit: R.identity
    };

    static propTypes = {
        onCancel: PropTypes.func,
        onSubmit: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedOptions: null,
            feedbackText: '',
            rating: null
        };
    }

    onSelect = selectedOptions => this.setState({selectedOptions});

    onTextChange = e => this.setState({feedbackText: e.target.value});

    onRating = rating => this.setState({rating});

    onSubmit = () => {
        const {onSubmit} = this.props;
        const {selectedOptions, feedbackText, rating} = this.state;
        const feedback = R.trim(feedbackText);
        onSubmit({
            reasons: R.pipe(
                R.filter(R.identity),
                R.keys
            )(selectedOptions),
            feedback: feedback === '' ? null : feedback,
            rating
        });
    };

    render() {
        const {isTransmitting} = this.props;
        const {selectedOptions, rating} = this.state;
        const hasSelectedOption = R.any(R.identity, R.values(selectedOptions));
        const hasRating = rating !== null;
        return (
            <FeedbackPanel
                heading="You have approved this piece of content"
                subheading="To improve future content, please select one or more reasons."
                onCancel={this.props.onCancel}
                onSubmit={this.onSubmit}
                submitDisabled={!hasSelectedOption || !hasRating || isTransmitting}
            >
                <FeedbackForm
                    options={feedbackOptions}
                    onSelect={this.onSelect}
                    onTextChange={this.onTextChange}
                />
                <div className="missed-guidelines-approved-feedback__text">
                    To improve future matching, rate this content:
                </div>
                <Rate items={5} value={0} onRating={this.onRating} icon={Star} />
            </FeedbackPanel>
        );
    }
}



// WEBPACK FOOTER //
// ./components/missed_guidelines_approved_feedback/index.js